import type { Table } from '@tanstack/react-table';
import { Columns3 } from 'lucide-react';
import { t } from '@/lib/i18n';
import { IconButton } from '../IconButton';
import { Menu, MenuCheckboxItem, MenuItem, MenuLabel, MenuSeparator } from '../Menu';

export function ColumnChooser<T>({ table, onReset }: { table: Table<T>; onReset: () => void }) {
  const columns = table.getAllLeafColumns().filter((c) => c.getCanHide());
  return (
    <Menu trigger={<IconButton icon={Columns3} label={t('Choose columns')} size="sm" />} label={t('Choose columns')}>
      <MenuLabel>{t('Columns')}</MenuLabel>
      {columns.map((c) => (
        <MenuCheckboxItem key={c.id} checked={c.getIsVisible()} onChange={(v) => c.toggleVisibility(v)}>
          {String(c.columnDef.meta?.header ?? c.id)}
        </MenuCheckboxItem>
      ))}
      <MenuSeparator />
      <MenuItem onSelect={onReset}>{t('Reset columns')}</MenuItem>
    </Menu>
  );
}
